import React, { useState, useContext, useEffect, useMemo } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import { drawerStyles } from "./styles";
import Avatar from "@mui/material/Avatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import useMediaQuery from "@mui/material/useMediaQuery";

import useTheme from "@mui/material/styles/useTheme";
import SearchBar from "../../../common/SearchBar";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

import AuthAPI from "../../../../api/firebase/AuthAPI";
import ColorModeContext from "../../../../context/colorMode/ColorModeContext";
import CustomButton from "../../../common/Button/CustomButton";
import UserProfileContext from "../../../../context/userProfile/UserProfileContext";
import Dialog from "@mui/material/Dialog";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { MyList } from "./styledComponents";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import Badge from "@mui/material/Badge";
import LoginPage from "../../../../pages/authentication/login";
import CloseIcon from "@mui/icons-material/Close";
import AllCategoriesContext from "../../../../context/allCategories/AllCategoriesContext";
import CustomMenu from "./CustomMenu";
import CartItemsContext from "../../../../context/cartItems/CartItemsContext";
import LikedItemsContext from "../../../../context/likedItems/LikedItemsContext";
import AllProductContext from "../../../../context/allProducts/AllProductsContext";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { Logout } from "@mui/icons-material";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import PinDropIcon from "@mui/icons-material/PinDrop";
import SearchResultsBox from "./SearchResultsBox";
import ScrollToColor from "./ScrollToColor";
import SaleBanner from "../SaleBanner";
import logo from "../../../../assets/images/inproveda-logo.png";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import {
  categoryHasProducts,
  getCategoryImageUrl,
} from "../../../../utils/categoryProducts";
const drawerWidth = 240;
const WHATSAPP_URL = "https://api.whatsapp.com/send/?phone=919411174186";
const PHONE_HREF = "tel:+919411174186";
const basePath = "/collections";

const collapseSingleItemSubmenus = (items) =>
  items.map((item) => {
    const submenu = collapseSingleItemSubmenus(item.submenu || []);
    return {
      ...item,
      submenu: submenu.length === 1 ? [] : submenu,
    };
  });

const buildNestedMenu = (items) => {
  const menu = [];
  const itemMap = {};

  for (const item of items) {
    itemMap[item.id] = {
      id: item.id,
      title: item.name,
      link: `${basePath}/${item.id}`,
      parentCategory: item.parentCategory,
      imageUrl: getCategoryImageUrl(item),
      submenu: [],
    };
  }

  for (const id in itemMap) {
    const item = itemMap[id];
    if (item.parentCategory.id !== "None") {
      if (itemMap[item.parentCategory.id] !== undefined) {
        itemMap[item.parentCategory.id].submenu.push(item);
      }
    } else {
      menu.push(item);
    }
  }

  return menu;
};


const DrawerAppBar = (props) => {
  const location = useLocation();
  const { pathname } = location;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openAccountMenu = Boolean(anchorEl);
  const handleClickAccountMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseAccountMenu = () => {
    setAnchorEl(null);
  };
  const [searchText, setSearchText] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchPanelOpen, setSearchPanelOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    if (mobileOpen) {
      handleDrawerToggle();
    }
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  function onSearchTextChange(e) {
    const value = e.currentTarget.value;
    setSearchText(value);
    setSearchPanelOpen(value.trim() !== "");
  }
  const theme = useTheme();
  const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const userProfileContext = useContext(UserProfileContext);
  const allCategoriesContext = useContext(AllCategoriesContext);
  const allProductsContext = useContext(AllProductContext);
  // console.log("categoriesArr:", categoriesArr);
  const profile = userProfileContext.state;
  const currentUser = profile?.id || profile?.uid ? profile : null;
  // console.log("DrawerAppBar currentUser:", currentUser);
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const authAPI = new AuthAPI();
  const cartItemsContext = useContext(CartItemsContext);
  const likedItemsContext = useContext(LikedItemsContext);
  let cartItemsArray = cartItemsContext.state;

  //console.log("cartItemsArray:", cartItemsArray);

  const [totalCartItems, setTotalCartItems] = useState(0);
  const [totalLikedItems, setTotalLikedItems] = useState(0);
  const navigate = useNavigate();
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const cancelSearchHandle = () => {
    setSearchText("");
    setSearchOpen(false);
    setSearchPanelOpen(false);
  };
  const openSearchHandle = () => {
    setSearchOpen(true);
  };
  const handleSearchFocus = () => {
    if (searchText.trim() !== "") {
      setSearchPanelOpen(true);
    }
  };
  const handleSearchClickAway = (event) => {
    if (event?.target?.closest?.(".search-dropdown")) {
      return;
    }
    setSearchPanelOpen(false);
    if (searchOpen) {
      cancelSearchHandle();
    }
  };
  useEffect(() => {
    if (userProfileContext.state?.id) {
      if (userProfileContext.state.likedItems) {
        likedItemsContext.setState(userProfileContext.state.likedItems);
      }
      if (userProfileContext.state.cartItems) {
        cartItemsContext.setState(userProfileContext.state.cartItems);
      }
    }
  }, [userProfileContext.state?.id]);

  const menuItems = useMemo(() => {
    const tempCategoriesArr = props.categories || allCategoriesContext.state;
    const products = props.products || allProductsContext.state || [];
    const menuForNavbar = tempCategoriesArr.filter((item) => {
      if (!item.showInNavbar) {
        return false;
      }
      if (!products.length) {
        return true;
      }
      return categoryHasProducts(item.id, products, tempCategoriesArr);
    });
    const nestedMenu = collapseSingleItemSubmenus(
      buildNestedMenu(menuForNavbar)
    );
    return nestedMenu;
  }, [
    props.categories,
    props.products,
    allCategoriesContext.state,
    allProductsContext.state,
  ]);

  useEffect(() => {
    if (cartItemsArray !== null) {
      const totItems = cartItemsArray.reduce(
        (n, { quantity }) => n + quantity,
        0
      );
      setTotalCartItems(totItems);
      // console.log("totItems:", totItems);
    } else {
      setTotalCartItems(0);
    }
  }, [cartItemsArray]);

  useEffect(() => {
    if (likedItemsContext.state !== null) {
      const totItems = likedItemsContext.state.length;
      setTotalLikedItems(totItems);
    } else {
      setTotalLikedItems(0);
    }
    // console.log("totItems:", totItems);
  }, [likedItemsContext.state]);

  const handleLogout = async () => {
    try {
      await authAPI
        .signoutUser()
        .then(() => {
          userProfileContext.setState(null);
          likedItemsContext.setState(null);
          cartItemsContext.setState(null);
          localStorage.clear();
          // console.log(
          //   "Sign out success: mobileOpen=",
          //   mobileOpen,
          //   " and openAccountMenu=",
          //   openAccountMenu
          // );
          if (mobileOpen) handleDrawerToggle();
          if (openAccountMenu) handleCloseAccountMenu();
          navigate("/");
        })
        .catch((err) => {
          console.log("Error in SignOut:", err);
        });
    } catch (ex) {
      console.log("Error sign out:", ex);
    }
  };

  /// For Mobile Drawer Container
  const greetName =
    currentUser?.displayName?.split(" ")[0] ||
    currentUser?.email?.split("@")[0] ||
    "";
  const drawer = (
    <div className="site-drawer-inner">
      <div className="site-drawer-head">
        <Link to="/" className="logo-link" onClick={handleDrawerToggle}>
          <img src={logo} alt={process.env.REACT_APP_NAME + " logo"} />
        </Link>
        <IconButton
          className="site-drawer-close"
          aria-label="close menu"
          onClick={handleDrawerToggle}
        >
          <CloseIcon />
        </IconButton>
      </div>

      <div className="site-drawer-user">
        <Avatar
          src={currentUser?.photoURL || undefined}
          alt={greetName || "Guest"}
          className="site-drawer-avatar"
        >
          {greetName ? greetName.charAt(0).toUpperCase() : null}
        </Avatar>
        <div className="site-drawer-user-copy">
          <p className="site-drawer-greet">
            {currentUser ? `Hi, ${greetName}` : "Welcome"}
          </p>
          <p className="site-drawer-sub">
            {currentUser
              ? "Manage orders and your account"
              : "Sign in to track orders and wishlist"}
          </p>
        </div>
        {currentUser ? (
          <button
            type="button"
            className="site-drawer-auth"
            onClick={handleLogout}
          >
            Logout
          </button>
        ) : (
          <button type="button" className="site-drawer-auth" onClick={handleOpen}>
            Sign in
          </button>
        )}
      </div>

      {currentUser?.role?.includes("Admin") && (
        <Link to="/admin" className="site-drawer-admin" onClick={handleDrawerToggle}>
          <AdminPanelSettingsIcon fontSize="small" />
          Admin panel
        </Link>
      )}

      <div className="site-drawer-quick">
        <Link
          to="/"
          className="site-drawer-quick-link"
          onClick={handleDrawerToggle}
        >
          <HomeOutlinedIcon fontSize="small" />
          <span>Home</span>
        </Link>
        <Link
          to="/userProfile"
          className="site-drawer-quick-link"
          onClick={handleDrawerToggle}
        >
          <PersonOutlineOutlinedIcon fontSize="small" />
          <span>Profile</span>
        </Link>
        <Link
          to="/userAddresses"
          className="site-drawer-quick-link"
          onClick={handleDrawerToggle}
        >
          <PinDropIcon fontSize="small" />
          <span>Addresses</span>
        </Link>
        <Link
          to="/userOrders"
          className="site-drawer-quick-link"
          onClick={handleDrawerToggle}
        >
          <ListOutlinedIcon fontSize="small" />
          <span>Orders</span>
        </Link>
        <Link
          to="/myWishlist"
          className="site-drawer-quick-link"
          onClick={handleDrawerToggle}
        >
          <FavoriteBorderOutlinedIcon fontSize="small" />
          <span>Wishlist</span>
          {totalLikedItems > 0 && (
            <span className="site-drawer-count wishlist-drawer-count">
              {totalLikedItems}
            </span>
          )}
        </Link>
        <Link
          to="/cart"
          className="site-drawer-quick-link"
          onClick={handleDrawerToggle}
        >
          <ShoppingCartOutlinedIcon fontSize="small" />
          <span>Cart</span>
          {totalCartItems > 0 && (
            <span className="site-drawer-count">{totalCartItems}</span>
          )}
        </Link>
      </div>

      <div className="site-drawer-section">
        <p className="site-drawer-label">Shop</p>
        <nav className="nav-area-mobile" aria-label="Shop categories">
          {menuItems.map((menu, index) => {
            const depthLevel = 0;
            return (
              <CustomMenu
                mobile={true}
                items={menu}
                key={index}
                depthLevel={depthLevel}
                onHandleToggle={handleDrawerToggle}
              ></CustomMenu>
            );
          })}
        </nav>
      </div>

      <div className="site-drawer-foot">
        <a
          className="site-drawer-contact site-drawer-whatsapp"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsAppIcon fontSize="small" />
          Chat on WhatsApp
        </a>
        <a className="site-drawer-contact" href={PHONE_HREF}>
          <PhoneOutlinedIcon fontSize="small" />
          Call us
        </a>
      </div>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <SaleBanner isMobile={mobileScreen} />
      <Box
        className="site-header-wrap"
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          position: "sticky",
          top: 0,
          zIndex: 1100,
        }}
      >
        <CssBaseline />
        <ScrollToColor pathname={pathname} isMobile={mobileScreen}>
          <AppBar
            position="static"
            component="nav"
            elevation={0}
            color="inherit"
            className="site-header"
            sx={{
              backgroundColor: "#ffffff",
              color: "#143833",
              boxShadow: "none",
              top: 0,
              overflow: "visible",
            }}
          >
            <Toolbar
              variant={mobileScreen ? "dense" : "regular"}
              className="site-header-inner"
              sx={{
                minHeight: { xs: 58, sm: 68 },
                overflow: "visible",
                px: { xs: 1.25, sm: 2 },
              }}
            >
              <IconButton
                color="inherit"
                aria-label="open menu"
                edge="start"
                className="header-action-btn"
                onClick={handleDrawerToggle}
                sx={{ mr: 0.5, display: { sm: "none" } }}
              >
                <MenuIcon />
              </IconButton>
              <Box className="site-header-brand">
                <Link to="/" className="logo-link">
                  <img
                    src={logo}
                    alt={process.env.REACT_APP_NAME + " logo"}
                    loading="lazy"
                  />
                </Link>
              </Box>
              {!mobileScreen && (
                <Box className="header-cat-nav">
                  <div className="nav-area header-cat-nav-inner">
                    <NavLink
                      to="/"
                      end
                      className="header-cat-link header-cat-home"
                    >
                      Home
                    </NavLink>
                    {menuItems.map((menu, index) => (
                      <CustomMenu
                        items={menu}
                        uniqueKey={index}
                        key={index}
                        depthLevel={0}
                        inBar={true}
                      />
                    ))}
                  </div>
                </Box>
              )}
              {mobileScreen && <Box sx={{ flexGrow: 1 }}></Box>}

              {/* <Box sx={{ flexGrow: 0 }}>
            <div className="action-link">
              <IconButton
                disableRipple={mobileScreen ? false : true}
                onClick={colorModeContext.toggleColorMode}
                color="inherit"
              >
                {theme.palette.mode === "dark" ? (
                  <LightModeIcon />
                ) : (
                  <Brightness3Icon />
                )}
              </IconButton>
            </div>
          </Box> */}
              <Box className="site-header-actions">
                <ClickAwayListener onClickAway={handleSearchClickAway}>
                  <Box className="site-header-search">
                    <SearchBar
                      expandable={mobileScreen}
                      expanded={searchOpen}
                      onExpand={openSearchHandle}
                      onCollapse={cancelSearchHandle}
                      onSearchTextChange={onSearchTextChange}
                      onFocus={handleSearchFocus}
                      searchText={searchText}
                    />
                    {searchText !== "" &&
                      searchPanelOpen &&
                      (searchOpen || !mobileScreen) && (
                      <SearchResultsBox
                        styles={{
                          width: { xs: "min(92vw, 440px)", sm: 420 },
                          minHeight: "auto",
                          position: "absolute",
                          top: "100%",
                          right: { xs: -8, sm: 0 },
                          marginTop: "10px",
                          maxHeight: "min(72vh, 560px)",
                          zIndex: 1300,
                        }}
                        searchText={searchText}
                        cancelSearchHandle={cancelSearchHandle}
                      />
                    )}
                  </Box>
                </ClickAwayListener>
                <MyList type="row">
                  {!mobileScreen && (
                    <IconButton
                      className="header-action-btn"
                      color="inherit"
                      aria-label="wishlist"
                      title="Wishlist"
                      onClick={() => navigate("/myWishlist")}
                      sx={{ display: { xs: "none", sm: "inline-flex" } }}
                    >
                      <Badge
                        badgeContent={totalLikedItems}
                        max={99}
                        color="error"
                        className="wishlist-badge"
                      >
                        {totalLikedItems > 0 ? (
                          <FavoriteIcon sx={{ color: "#e11d48" }} />
                        ) : (
                          <FavoriteBorderOutlinedIcon />
                        )}
                      </Badge>
                    </IconButton>
                  )}
                  {!mobileScreen && (
                    <IconButton
                      className="header-action-btn"
                      color="inherit"
                      aria-label="cart"
                      title="Cart"
                      onClick={() => navigate("/cart")}
                      sx={{ display: { xs: "none", sm: "inline-flex" } }}
                    >
                      <Badge
                        badgeContent={totalCartItems}
                        max={99}
                        color="primary"
                        className="cart-badge"
                      >
                        <ShoppingCartOutlinedIcon />
                      </Badge>
                    </IconButton>
                  )}
                  {currentUser !== null ? (
                    <IconButton
                      className="header-action-btn"
                      color="inherit"
                      onClick={handleClickAccountMenu}
                      aria-label="account"
                      title="Account"
                      aria-controls={
                        openAccountMenu ? "account-menu" : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={openAccountMenu ? "true" : undefined}
                    >
                      <PersonOutlineOutlinedIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      className="header-action-btn"
                      color="inherit"
                      aria-label="sign in"
                      title="Sign in"
                      onClick={handleOpen}
                    >
                      <LoginOutlinedIcon />
                    </IconButton>
                  )}
                </MyList>
              </Box>
            </Toolbar>
          </AppBar>
        </ScrollToColor>

        <Box component="nav">
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            className="site-drawer"
            PaperProps={{
              className: "site-drawer-paper",
              elevation: 0,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: "min(320px, 86vw)",
                backgroundColor: "#f7faf9",
                backgroundImage: "none",
                color: "#143833",
                borderRight: 0,
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="auth-dialog-title"
          maxWidth="xs"
          fullWidth
          scroll="body"
          PaperProps={{
            sx: {
              borderRadius: { xs: "20px", sm: "24px" },
              m: { xs: 2, sm: 3 },
              width: { xs: "calc(100% - 32px)", sm: "440px" },
              maxWidth: "440px",
              boxShadow:
                "0 25px 60px -15px rgba(7, 94, 84, 0.35), 0 0 0 1px rgba(7, 94, 84, 0.08)",
              overflow: "hidden",
              position: "relative",
              backgroundImage: "none",
              bgcolor: "#ffffff",
            },
          }}
          BackdropProps={{
            sx: {
              backdropFilter: "blur(8px)",
              backgroundColor: "rgba(10, 35, 30, 0.65)",
            },
          }}
        >
          <LoginPage handleCloseListener={handleClose} inDialog={true} />
        </Dialog>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={Boolean(currentUser) && openAccountMenu}
          onClose={handleCloseAccountMenu}
          onClick={handleCloseAccountMenu}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          {/* Link to admin */}
          {currentUser &&
            currentUser.role &&
            currentUser.role.includes("Admin") && (
              <div key="admin">
                <MenuItem onClick={handleCloseAccountMenu}>
                  <PersonOutlineOutlinedIcon sx={{ mr: "10px" }} /> Profile
                </MenuItem>
                <Link to="/admin">
                  <MenuItem>
                    <AdminPanelSettingsIcon sx={{ mr: "10px" }} /> Admin Panel
                    {/* <CustomButton
                  color="secondary"
                  variant="contained"
                  fullWidth
                  sx={drawerStyles.logoutButton}
                >
                  
                </CustomButton> */}
                  </MenuItem>
                </Link>
                <Link to="/userAddresses">
                  <MenuItem onClick={handleCloseAccountMenu}>
                    <PinDropIcon sx={{ mr: "10px" }} />
                    My Addresses
                  </MenuItem>
                </Link>
              </div>
            )}
          {currentUser &&
            currentUser.role &&
            !currentUser.role.includes("Admin") && (
              <div key="user">
                <Link to="/userProfile">
                  <MenuItem onClick={handleCloseAccountMenu}>
                    <PersonOutlineOutlinedIcon sx={{ mr: "10px" }} /> Profile
                  </MenuItem>
                </Link>
                <Link to="/userOrders">
                  <MenuItem onClick={handleCloseAccountMenu}>
                    <ListOutlinedIcon sx={{ mr: "10px" }} /> Orders
                  </MenuItem>
                </Link>
                <Link to="/userAddresses">
                  <MenuItem onClick={handleCloseAccountMenu}>
                    <PinDropIcon sx={{ mr: "10px" }} />
                    My Addresses
                  </MenuItem>
                </Link>
              </div>
            )}

          <Divider />

          {/* <MenuItem onClick={handleCloseAccountMenu}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem> */}
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </>
  );
};

export default DrawerAppBar;
